<template>
  <CloudPrintDetails
    class="class"
    >
    <template #header>
      <v-btn
        icon
        @click="$router.push({name: 'TaktPlanCloudPrints'})"
        >
        <v-icon>
          keyboard_arrow_left
        </v-icon>
      </v-btn>
      <v-spacer/>
      <input
        v-model="name"
        style="text-align: center; border-bottom: solid 1px white"
      >
      <v-spacer/>
      <v-btn
        small
        color="green"
        class="mr-1"
        @click="createCloudPrint()"
        >
        Create
      </v-btn>
    </template>
    <template #body>
      <TFlex class="mt-1 pl-2">
        Description:
      <input
        class="ml-2"
        type="textfield"
        style="width: 100% !important; border-bottom: solid 1px white"
        v-model="description"
      >
    </TFlex>
    <v-divider class="mt-2 mb-2" color="white" width="100%"></v-divider>
    <TFlex class="mt-1 pl-2">
      <StandardSwitch
        :value="is_public"
        label="Public Print"
        @changeValue="is_public = !is_public"
        />
      <StandardSwitch
        class="ml-10"
        v-if="is_public"
        :value="limit_access_time"
        label="Limit Access Time"
        @changeValue="limit_access_time = !limit_access_time"
        />
        <StandardSwitch
        class="ml-10"
        v-if="is_public"
        :value="show_expires_at"
        label="Expires at"
        @changeValue="show_expires_at = !show_expires_at"
      />
    </TFlex>
    <template v-if="is_public && limit_access_time">
      <TFlex class="ml-2 mt-2" style="align-items: center">
        <v-btn
          v-for="day in [
            {name: 'Mo', prop: 'monday'},
            {name: 'Tu', prop: 'tuesday'},
            {name: 'We', prop: 'wednesday'},
            {name: 'Th', prop: 'thursday'},
            {name: 'Fr', prop: 'friday'},
            {name: 'Sa', prop: 'saturday'},
            {name: 'Su', prop: 'sunday'},
          ]"
          :key="day.name"
          class="ml-1 mr-1"
          rounded
          :style="`min-width: 0px; width: 36px; margin: 0px;`"
          :color="$data[day.prop]?'blue':''"
          @click="$data[day.prop] = !$data[day.prop]"
          >
          {{day.name}}
        </v-btn>
        <v-spacer/>
        <input type="time" v-model="start_time" class="grey">
        <div class="ml-2 mr-2"> to</div>
        <input type="time" v-model="end_time" class="grey">
        <v-spacer/>
      </TFlex>
    </template>
    <template v-if="is_public && show_expires_at">
      <StandardDateSelector
        @input="expires_at = `${$event} 12:00:00`"
        :value="expires_at"
        first_day_of_week="Mo"
        persistant="false"
      />
    </template>
    <v-divider class="mt-2 mb-2" color="white" width="100%"></v-divider>
    <div>Statistic Settings</div>
    <template v-if="location === 'ProjectTaktPlan'">
      <TFlex align_items="center">
      <StandardOverflowButton
        ref="statisticSettingsCloudPrintCreate"
        tooltip="value"
        ticon="takt-plan-workpackage"
        :click_to_open="true"
        :value="{value: getStatisticSettings.value}"
        :options="{value: [
            {value: 'workpackages', ticon: 'takt-plan-workpackage', icon: 'dns', tooltip: 'Number of WORK.packages'},
            {value: 'time_effort_planned', ticon: 'speedometer', icon: 'speed', tooltip: 'Planned time effort'},
            {value: 'manpower_planned', ticon: 'person-standing', icon: 'accessibility', tooltip: 'Planned manpower'},
            {value: 'duration_planned', ticon: 'stopwatch', icon: 'timer', tooltip: 'Duration planned'},
            {value: 'time_effort_actual', ticon: 'speedometer', icon: 'speed', tooltip: 'Actual time effort'},
            {value: 'manpower_actual', ticon: 'person-standing', icon: 'accessibility', tooltip: 'Actual manpower'},
            {value: 'duration_actual', ticon: 'stopwatch', icon: 'timer', tooltip: 'Actual duration'},
            {value: 'twork_step_count', ticon: $store.state.Ultra.step_icons['work'], icon: 'list', tooltip: 'Number of WORK.steps'},
            {value: 'tdesign_step_count', ticon: $store.state.Ultra.step_icons['design'], icon: 'design_services', tooltip: 'Number of DESIGN.steps'},
            {value: 'tlogistic_step_count', ticon: $store.state.Ultra.step_icons['logistic'], icon: 'airport_shuttle', tooltip: 'Number of LOGISTIC.steps'},
            {value: 'tquality_step_count', ticon: $store.state.Ultra.step_icons['quality'], icon: 'high_quality', tooltip: 'Number of QUALITY.steps'},
            {value: 'tdefect_step_count', ticon: $store.state.Ultra.step_icons['defect'], icon: 'broken_image', tooltip: 'Number of DEFECT.steps'},
            {value: 'thandover_step_count', ticon: $store.state.Ultra.step_icons['handover'], icon: 'sync_alt', tooltip: 'Number of HANDOVER.steps'},
            {value: 'image_count', ticon: 'image', icon: 'photo', tooltip: 'Number of images'},
            {value: 'log_entry_count', ticon: 'clipboard-pencil', icon: 'book', tooltip: 'Number of LOG.entries'},
            {value: 'costs_budget_labour', ticon: 'wallet', icon: 'account_balance_wallet', tooltip: 'Labour budget'},
            {value: 'costs_budget_material', ticon: 'wallet', icon: 'account_balance_wallet', tooltip: 'Material budget'},
            {value: 'costs_paid_out_labour', ticon: 'money', icon: 'payments', tooltip: 'Labour paid out'},
            {value: 'costs_paid_out_material', ticon: 'money', icon: 'payments', tooltip: 'Material paid out'},
            {value: 'costs_paid_tendered_labour', ticon: 'shopping-cart', icon: 'shopping_cart', tooltip: 'Labour tendered'},
            {value: 'costs_paid_tendered_material', ticon: 'shopping-cart', icon: 'shopping_cart', tooltip: 'Material tendered'},
            {value: 'calendar', ticon: 'calendar', icon: 'calendar_today', tooltip: 'Calendar'},
          ]}"
        @select-option="setStatisticSettings({setting: $event.setting, value: $event.value, project_id: project_id})"
        style="position: relative; width: 100%; overflow: auto"
        />
      </TFlex>
      <TFlex align_items="center">
      <StandardOverflowButton
        ref="statisticSettingsCumulativeCloudPrintCreate"
        tooltip="cumulative"
        ticon="poll"
        :click_to_open="true"
        :value="{cumulative: getStatisticSettings.cumulative}"
        :options="[
          'manpower_planned',
          'manpower_actual',
          'time_effort_planned',
          'time_effort_actual',
          'calendar',
          ].includes(getStatisticSettings.value)?
          {cumulative: [
            {value: false, ticon: 'poll', icon: 'bar_chart', tooltip: 'Cumulative'},
          ]}
          :
          {cumulative: [
            {value: false, ticon: 'poll', icon: 'bar_chart', tooltip: 'Per TAKT.time'},
            {value: true, ticon: 'ascending', icon: 'signal_cellular_alt', tooltip: 'Cumulative'}
          ]}
        "
        @select-option="setStatisticSettings({setting: $event.setting, value: $event.value, project_id: project_id})"
        style="position: relative; width: 100%; overflow: auto"
        />
      </TFlex>
      <v-divider class="mt-2 mb-2" color="white" width="100%"></v-divider>
      <TFlex align_items="center">
      <div>Filter Settings</div>
      <StandardOverflowButton
        ref="filterCloudPrintCreate"
        tooltip="Set Filter"
        :click_to_open="true"
        icon="filter_alt"
        ticon="filter"
        :multiselect="true"
        :button_color="getStatisticSettings.filter? 'color-3':''"
        :value="{
          icons: getStatisticSettings.icons,
          colors: getStatisticSettings.colors,
          status: getStatisticSettings.status,
          trains: getStatisticSettings.trains
          }"
        :options="{
          icons: getTWorkpackageIcons,
          colors: getTWorkpackageColors,
          status: getFullStatusArray,
          trains: getStatisticsTrainSelector(project_id),
          }
          "
        @select-option="setStatisticSettings({setting: $event.setting, value: $event.value, project_id: project_id})"
        />
        </TFlex>
        <div v-if="!settings.filter">No filter</div>
        <template v-if="settings.filter">
          <div>icons: {{settings.icons}}</div>
          <div>colors: {{settings.colors}}</div>
          <div>status: {{settings.status}}</div>
          <div>trains: {{settings.trains}}</div>
        </template>
      <v-divider class="mt-2 mb-2" color="white" width="100%"></v-divider>

      <div>Open Trains:</div>
      <div v-for="train in getUObjectsFiltered({
          type: 'trains',
          filter: {closed: false}
        })"
        :key="train.id"
        >
        {{train.name}}
      </div>
    </template>
    <v-divider class="mt-2 mb-2" color="white" width="100%"></v-divider>
    </template>
  </CloudPrintDetails>
</template>
<script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import CloudPrintDetails from '@/components/CloudPrint/CloudPrintDetails.component.vue'
  import TFlex from '@/components/Taktify/TFlex.component.vue'
  import StandardSwitch from '@/components/StandardComponents/StandardSwitch.component.vue'
  import StandardOverflowButton from '@/components/StandardComponents/StandardOverflowButton.component.vue'
  import StandardDateSelector from '@/components/StandardComponents/StandardDateSelector.component.vue'

  export default {
    props: ['project_id', 'location', 'settings'],
    components: {
      CloudPrintDetails,
      TFlex,
      StandardSwitch,
      StandardOverflowButton,
      StandardDateSelector
    },
    data: () => ({
      name: 'New CLOUD.print',
      description: '',
      is_public: true,
      allow_comments: false,
      limit_access_time: false,
      show_expires_at: false,
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true,
      sunday: true,
      start_time: "08:00",
      end_time: "18:00",
      expires_at: "",
    }),
    computed: {
      ...mapState('View', [
        'taktplan_zoom',
      ]),
      ...mapState('ProjectStatistics', [
        'statistic_settings',
      ]),
      ...mapState('ProjectWallet', [
        'wallet_settings',
      ]),
      ...mapGetters('Ultra', [
        'getUObjectsFiltered',
      ]),
      ...mapGetters('ProjectStatistics', [
        'getStatisticSettings',
      ]),
      ...mapGetters('Project', [
        'getFullStatusArray',
        'getStatisticsTrainSelector',
      ]),
      ...mapGetters('TWorkPackage', [
        'getTWorkpackageIcons',
        'getTWorkpackageColors',
      ]),
    },
    methods: {
      ...mapActions('Ultra', [
        'createUObject',
      ]),
      ...mapActions('ProjectStatistics', [
        'setStatisticSettings',
      ]),
      createCloudPrint() {
        this.$refs.statisticSettingsCloudPrintCreate.closeFilter();
        this.$refs.statisticSettingsCumulativeCloudPrintCreate.closeFilter();
        this.$refs.filterCloudPrintCreate.closeFilter();

        let cloudprint = JSON.parse(JSON.stringify(this.$data));
        cloudprint.settings = {
          project_id: this.project_id,
          taktplan_zoom: JSON.parse(JSON.stringify(this.taktplan_zoom)),
          init_route_name: this.$route.matched[1].name,
          trains_open: [],
        };

        this.getUObjectsFiltered({
            type: 'trains',
            filter: {closed: false}
          }).forEach(train => {
            cloudprint.settings.trains_open.push(JSON.parse(JSON.stringify(train.id)));
          });

        if (this.$route.matched[1].name === 'ProjectTaktPlan') {
          cloudprint.settings.statistic_settings = JSON.parse(JSON.stringify(this.statistic_settings));
        } else if (this.$route.matched[1].name === 'ProjectWallet') {
          cloudprint.settings.wallet_settings = JSON.parse(JSON.stringify(this.wallet_settings));
        }
        this.createUObject({
          url: [
            {projects: this.project_id},
            {cloudprints: ''},
            {showWithEntitiesNormalized:''}
          ],
          u_object: cloudprint
        })
    },
  }
  }
</script>
<style>
  .class {

  }
  input[type=time] {
    color: white
  }
</style>
